import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {VirtualMetricOPEEnum} from "./VirtualMetricOPEEnum";

class I {
  virtualMetricId!: number;
  name?: string;
}

class O {
  id!: number;
}

export class DuplicateVirtualMetricCB extends BaseSpringServiceCB {
  public i: I;
  public o: O;

  constructor() {
    super(VirtualMetricOPEEnum.DuplicateVirtualMetric);
    this.i = new I();
    this.o = new O();
  }
}
